import React from 'react';
import { connect } from 'react-redux';
import Logout from './Logout';
import SignUp from './SignUp';
import Dashboard from './Dashboard';
import Home from '../Home';
import LoadingScreen from '../../components/LoadingScreen';
import ProtectedRoute from '../../components/ProtectedRoute';
import SessionExpiredPrompt from '../../components/SessionExpiredPrompt';
import EdgeImageUploadWarn from '../../components/Banners/EdgeImageUploadWarn';
import PropertyRefreshContextProvider from '../../components/PropertyRefreshContextProvider';
import useFetchEffect from '../../hooks/useFetchEffect';
import { fetchPropertyOwner as apiFetchPropertyOwner } from '../../api/propertyowners';
import Document from './Dashboard/Documents/Document';
import { acSetAuthInfo } from '../../store/actions/auth';
import CancelledSubscriptionRedirectPage from './CancelledSubscriptionRedirectPage';
import SuccessfulPurchase from './SuccessfulPurchase';
import useSyncRefreshToken from '../../hooks/v2/useSyncRefreshToken';

export const PrivateRoutes = ({ setAuthInfo }) => {
  const loading = useSyncRefreshToken();

  useFetchEffect({
    initialDataState: {},
    defaultDataState: {},
    initialFetchingState: true,
    apiFetchFunction: apiFetchPropertyOwner,
    onSuccess: (data) => setAuthInfo({ user: { ...data }, loaded: true }),
  });

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <PropertyRefreshContextProvider>
      <EdgeImageUploadWarn />

      <ProtectedRoute path="/properties" component={Home} />
      <ProtectedRoute
        exact
        path="/personal-documents/:documentId"
        component={Document}
      />
      <ProtectedRoute
        exact
        path="/subscription-cancelled"
        component={CancelledSubscriptionRedirectPage}
      />
      <ProtectedRoute
        exact
        path="/successful-subscription"
        component={SuccessfulPurchase}
      />

      <ProtectedRoute
        path="/dashboard/:boligmappaNumber"
        component={Dashboard}
      />

      <ProtectedRoute exact path="/logout" component={Logout} />

      <ProtectedRoute exact path="/signup" component={SignUp} />

      <SessionExpiredPrompt />
    </PropertyRefreshContextProvider>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setAuthInfo: (user) => dispatch(acSetAuthInfo(user)),
});

export default connect(null, mapDispatchToProps)(PrivateRoutes);
